import React from 'react';
import { Link } from 'react-router-dom';

interface CustomProps {
  itemPosition?: number;
  route?: string;
  defaultValue?: string;
  value?: string | number | any[] | any;
  separationChar?: string;
  noLink?: boolean;
  record?: {
    _id: string;
  };
}
const Component: React.SFC<CustomProps> = (props) => {
  const { route, record, defaultValue } = props;
  let { value } = props;

  if (Array.isArray(props.value)) {
    for (let x = 0; x < value.length; x += 1) {
      value[x] = value[x].charAt(0).toUpperCase() + value[x].substr(1);
    }
    return value.join(` ${props.separationChar ? props.separationChar : '|'} `);
  }
  if (typeof value === 'string') {
    value = value.charAt(0).toUpperCase() + value.substr(1);
  }
  if (!value && defaultValue) {
    value = defaultValue;
  }

  return props.itemPosition === 0 && !props.noLink ? (
    <Link
      className="CrudTextField table-tbody__item--bold"
      to={`/${route}/${(record && record._id) || ''}`}
    >
      {value}
    </Link>
  ) : (
    <div className="CrudTextField">{value}</div>
  );
};

Component.defaultProps = {
  itemPosition: 1,
};

export default Component;
